import React from "react";
import { Component } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import compose from "lodash.flowright";
import CardLessDataTableWithSearch from "../datatables/CardLessDataTableWithSearch";
import LongOMRModal from "./LongOmrModal";
import moment from "moment";

// GraphQL query to fetch OMR details
const GET_OMR_DETAILS = gql`
  query ($institution_id: Int!) {
    getOMRExamResults(institute_id: $institution_id) {
      exam
      exam_name
      class
      section
      exam_paper_id
      pending_omr
      processing_omr
      updated_omr
      rejected_omr
      total_omr
      start_time
      end_time
    }
  }
`;

class NewOmrHistory extends Component {
  constructor() {
    super();
    this.state = {
      viewDetails: false,
      paperId: null,
      selectOption: 1,
    };
  }

  articlecolumns = [
    {
      dataField: "id",
      text: "S.No",
      sort: false,
    },
    {
      dataField: "date",
      text: "Exam Date",
      sort: true,
    },
    {
      dataField: "exam_name",
      text: "Exam Name",
      sort: true,
    },
    {
      dataField: "exam",
      text: "Exam Type",
      sort: true,
    },
    {
      dataField: "class",
      text: "Class",
      sort: true,
    },
    {
      dataField: "section",
      text: "Sections",
      sort: true,
    },
    {
      dataField: "total_omr",
      text: "Total Uploaded OMR",
      sort: false,
    },
    {
      dataField: "processing_omr",
      text: "In-Process OMR",
      sort: false,
    },
    {
      dataField: "updated_omr",
      text: "Updated OMR",
      sort: false,
    },
    {
      dataField: "rejected_omr",
      text: "Error OMR",
      sort: false,
    },
    {
      dataField: "view_details",
      formatter: this.performanceFunc.bind(this),
      text: "View OMR Details",
    },
  ];

  // Format and return table data
  tableData() {
    const data = this.props.getStudents.getOMRExamResults;
    const resultArray = [];

    if (!data) return [];

    data.forEach((item, index) => {
      resultArray.push({
        id: index + 1,
        date: moment.unix(item.start_time).format("DD/MM/YYYY"),
        exam_name: item.exam_name,
        exam: item.exam,
        class: item.class,
        section: item.section,
        total_omr: item.total_omr,
        updated_omr: item.updated_omr,
        processing_omr: item.processing_omr,
        pending_omr: item.pending_omr,
        rejected_omr: item.rejected_omr,
        exam_paper_id: item.exam_paper_id,
        view_details: "",
      });
    });

    return resultArray;
  }

  // Renders the "View Details" button
  performanceFunc(val, row) {
    return (
      <div className="actions-buttons d-flex justify-content-center align-items-top">
        <Button
          variant="link"
          name="edit"
          className="text-theme"
          onClick={() =>
            this.setState({ viewDetails: true, paperId: row.exam_paper_id })
          }
        >
          <i className="fa fa-eye text-dark" />
        </Button>
      </div>
    );
  }
  render() {
    const { getStudents } = this.props;
    const { loading, error } = getStudents;

    if (error) {
      alert("Server Error. " + error.message);
      return null;
    }
    return (
      <>
        <Container style={{ background: "#ffffff" }}>
          {loading ? (
            <Container>
              <Row className="my-2">
                <Col>
                  <div className="spinner-border text-primary text-center loading-img-center"></div>
                </Col>
              </Row>
            </Container>
          ) : (
            <>
              <CardLessDataTableWithSearch
                parentData={this.tableData()}
                particlecolumns={this.articlecolumns}
                name="hostel_attendance"
              />

              <LongOMRModal
                stateData={this.state}
                show={this.state.viewDetails}
                onHide={() => this.setState({ viewDetails: false })}
              />
            </>
          )}
        </Container>
      </>
    );
  }
}
export default compose(
  graphql(GET_OMR_DETAILS, {
    options: () => ({
      variables: {
        institution_id: parseInt(Cookies.get("institutionid")),
      },
      fetchPolicy: "network-only", // ⬅️ Always fetch from server
    }),
    name: "getStudents",
  })
)(NewOmrHistory);
